export default "__VITE_ASSET__BpIAoleN__"